

// TEST SERVICE-API URL
// export const HOSTNAME = 'http://localhost:8081';


// TEST LDA URL
// export const LargeDataAnalyticsHostname = 'http://localhost:8080';

// PRODUCTION URLS

export const HOSTNAME = 'https://r-9-4-2024---service-api-d6vxitfn5a-uc.a.run.app';
export const LargeDataAnalyticsHostname = 'https://r-8-28-2024-v2---large-data-analytics-d6vxitfn5a-uc.a.run.app';


export const GoogleCloudStorageBucketUrl = 'https://storage.googleapis.com/users-webapp-platform-storage/';


export const UPLOAD_URL = `${HOSTNAME}/files/editor/upload`;
export const FETCH_RESOURCE_URL = `${HOSTNAME}/files/serve`;


